import type { FCWithChildren } from "koljobs-types";

export const CardFormContainer: FCWithChildren = ({ children }) => {
  return (
    <div className="w-full space-y-3 bg-white p-4 sm:space-y-6 sm:rounded-lg sm:p-8 sm:shadow">
      {children}
    </div>
  );
};
